import { useUpdateContractUserCountMutation } from '@crew/apis/dist/contract/contractApis'
import { useTranslation } from '@crew/modules/dist/i18n'
import { useCrewNavigate } from 'hooks/useCrewNavigate'
import { useShowApiErrors } from 'hooks/useShowApiErrors'
import { useToast } from 'hooks/useToast'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'

export type FormValues = {
  contractUserCount: number
}

export const useContractPurchaseUserPage = (
  contractUserCount: number | undefined
) => {
  const { control, handleSubmit, setValue } = useForm<FormValues>({
    criteriaMode: 'all',
    defaultValues: {
      contractUserCount: contractUserCount,
    },
  })

  const [showApiErrors] = useShowApiErrors()

  const [
    updateContractUserCountMutation,
    { isLoading: updateContractUserCountLoading },
  ] = useUpdateContractUserCountMutation()

  const { t } = useTranslation()

  const { success } = useToast()

  const { historyBack, navigate } = useCrewNavigate()

  // 更新時の処理
  const updateContractUserCount = useCallback(() => {
    const onSubmit = async (data: FormValues) => {
      try {
        await updateContractUserCountMutation({
          contractUserCount: data.contractUserCount,
        }).unwrap()

        // トーストを出しつつ
        success(t('message.contract.updateContractUserCountSuccess'))

        // 処理に成功したら請求ポータル画面に遷移する
        navigate('/contract/portal')
      } catch (error) {
        showApiErrors(error)
      }
    }

    handleSubmit(onSubmit)()
  }, [
    handleSubmit,
    navigate,
    showApiErrors,
    success,
    t,
    updateContractUserCountMutation,
  ])

  const cancelUpdateContractUserCount = useCallback(() => {
    historyBack()
  }, [historyBack])

  return {
    control,
    setValue,
    updateContractUserCount,
    cancelUpdateContractUserCount,
    updateContractUserCountLoading,
  }
}
